import { IReducerAction } from 'src/interfaces/redux';
import { IPlaylist } from 'src/interfaces/Playlist';
export * from './resolution.selectors';

export interface IResolutionState {
  playlist: IPlaylist[];
  resolution: IPlaylist;
}

export const resolutionInitialState: IResolutionState = {
  playlist: [],
  resolution: {
    src: 'Auto',
    type: 'application/x-mpegURL',
    label: 'Auto',
    bandwidth: 'Auto',
  },
};

export enum ResolutionActionTypes {
  SET_PLAYLIST = 'RESOLUTION/SET_PLAYLIST',
  SET_RESOLUTION = 'RESOLUTION/SET_RESOLUTION',
}

export type IResolutionAction = IReducerAction<ResolutionActionTypes>;

export default function resolutionReducer(state: IResolutionState = resolutionInitialState, action: IResolutionAction) {
  switch (action.type) {
    case ResolutionActionTypes.SET_PLAYLIST:
      return { ...state, playlist: action.payload };
    case ResolutionActionTypes.SET_RESOLUTION:
      return { ...state, resolution: action.payload };
    default:
      return state;
  }
}
